clubs:
  title: "Clubs"
  subtitle: "Beheer de clubs en bij welke federatie ze horen."
  empty: "Nog geen clubs toegevoegd."
  searchPlaceholder: "Zoek op naam"
  create: "Club toevoegen"
  edit: "Club aanpassen"
  created: "Club toegevoegd."
  updated: "Club bijgewerkt."
  deleted: "Club verwijderd."
  deleteConfirmTitle: "Club verwijderen?"
  federation: "Federatie"
  email: "E-mailadres"
  emailHint: "Voor meldingen wanneer een lid zich aanmeldt voor een taak. Optioneel."
  logo: "Logo"
  logoHint: "PNG of JPG."
  removeLogo: "Logo verwijderen"
  initialUserEmail: "E-mailadres eerste beheerder"
  initialUserEmailHint: "Deze gebruiker wordt direct clubbeheerder met de rol Beheerder."
  statistics:
    title: "Statistieken"
    users: "Gebruikers"
    activated: "{activated} geactiveerd ({percentage}%)"
    members: "Leden"
    paidOff: "Afgekocht"
    exemptions: "Vrijgesteld"
    categories: "Categorieën"
    tasks: "Taken"
    activePeriod: "Afgekocht en vrijgesteld gelden voor de actieve periode: {period}."
    noActivePeriod: "Er is geen actieve periode, dus afgekocht en vrijgesteld staan op 0."
    failed: "Statistieken konden niet worden geladen."
  columns:
    name: "Naam"
    id: "ID"
    federation: "Federatie"
